/* eslint-disable react/destructuring-assignment */
import DashboardLayout from "modules/LayoutContainers/DashboardLayout";
import PropTypes from "prop-types";
import React from "react";

class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError(error) {
    // Update state so the next render will show the fallback UI.
    return { hasError: true };
  }

  componentDidCatch(error, errorInfo) {
    // You can also log the error to an error reporting service
    console.error(error, errorInfo);
  }

  render() {
    if (this.state.hasError) {
      // You can render any custom fallback UI
      return (
        <DashboardLayout>
          <h1>Something went wrong. Please try again later.</h1>
          <code>
            We apologize for the inconvenience. If you continue to experience issues, please contact
            our support team at <a href="mailto:xane@xane.ai">xane@xane.ai</a>.
          </code>
        </DashboardLayout>
      );
    }

    return this.props.children;
  }
}

ErrorBoundary.propTypes = {
  children: PropTypes.node.isRequired,
};

export default ErrorBoundary;
